/**
 * Polyfill for process - MUST be imported first before any other modules
 * This ensures process is available before any module tries to access it
 * 
 * Webpack DefinePlugin replaces process.env.REACT_APP_* with actual string values at build time.
 * However, some code may check for process existence or access process.env dynamically,
 * so we need to provide a process object in the browser.
 */

// Create process.env object
// Note: Webpack DefinePlugin will replace process.env.REACT_APP_* references at build time
// This object is mainly for code that checks process existence or accesses process.env dynamically
const processEnv: Record<string, string> = {};

// Create the process object
const processPolyfill = { env: processEnv };

// Set up process on globalThis (works in both browser and Node.js-like environments)
// This is the modern way to set global variables that works in all environments
if (typeof globalThis !== 'undefined') {
    // @ts-ignore - We're intentionally setting a global variable
    if (typeof globalThis.process === 'undefined') {
        // @ts-ignore
        globalThis.process = processPolyfill;
    }
}

// Set up process on window for browser compatibility (some code may access window.process)
if (typeof window !== 'undefined') {
    if (typeof (window as any).process === 'undefined') {
        (window as any).process = processPolyfill;
    }
}

// Set up process on global for Node.js-like environments
if (typeof global !== 'undefined') {
    if (typeof (global as any).process === 'undefined') {
        (global as any).process = processPolyfill;
    }
}

// For strict mode modules, we also need to ensure process is available
// by creating a getter on the global object
try {
    // @ts-ignore
    if (typeof process === 'undefined') {
        // Use Object.defineProperty to create a non-configurable property
        // This ensures it's available even in strict mode
        if (typeof globalThis !== 'undefined') {
            Object.defineProperty(globalThis, 'process', {
                value: processPolyfill,
                writable: true,
                configurable: true,
            });
        }
    }
} catch (e) {
    // Ignore errors if we can't define the property
}

export {};

